module.exports = __webpack_public_path__ + "static/media/img47.7dc6b84a.jpg";